import React from 'react'
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import Cookies from "js-cookie"
const firebaseConfig = {
    apiKey: "AIzaSyAI8tZx3Y6Z8ripS8InGHdVpI47hzns7nw",
    authDomain: "bluefieldoman-web.firebaseapp.com",
    projectId: "bluefieldoman-web",
    storageBucket: "bluefieldoman-web.appspot.com",
    messagingSenderId: "983987095951",
    appId: "1:983987095951:web:3eca468cc76c5f043323fa",
    measurementId: "G-5BZE2QHC49"
};
const app = initializeApp(firebaseConfig);

async function initializeMessaging() {
    const supported = await isSupported();
    
    if (!supported) {
        console.warn("Firebase Messaging is not supported in this browser.");
        return null;
    }

    return getMessaging(app);
}

export const generateToken = async () => {
    const messaging = await initializeMessaging();
    
    if (!messaging) {
        console.warn("FCM not initialized due to unsupported browser.");
        return null;
    }

    const permission = await Notification.requestPermission();

    if (permission === "granted") {
        Cookies.set("notificationPermission", "granted");

        try {
            const token = await getToken(messaging, {
                vapidKey: "BI8zdW0RdZvYo7RpFH0dv6C7W2jv6nWia1EIMTeYGe_qyRPHZKvGQJ7i-T3uBcPWhTlWkeeD0zwmbFBkQBIwXHs",
            });
            return token;
        } catch (error) {
            console.error("Error getting FCM token:", error);
            return null;
        }
    } else {
        console.warn("Notification permission denied.");
    }

    return null;
};

export { initializeMessaging };